export default "__VITE_ASSET__972ee95b__"